// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchFilters_wrapper__weGWs","header":"SearchFilters_header__UiHUQ","headerName":"SearchFilters_headerName__6wtjH"};